export const ShopperAgentOutboundMessageKind = {
  Outreach: "outreach",
  Reply: "reply",
} as const;

export type ShopperAgentOutboundMessageKind =
  (typeof ShopperAgentOutboundMessageKind)[keyof typeof ShopperAgentOutboundMessageKind];
